import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const Logout = ({ checkLoginStatus }) => {
  const history = useHistory();

  useEffect(() => {
    // Clear all session data
    sessionStorage.clear();
    
    // Clear all local storage data
    localStorage.clear();
    
    // Update login status in parent component
    if (checkLoginStatus) {
      checkLoginStatus();
    }
    
    // Navigate to login page without reload
    history.push('/page/login');
  }, [history, checkLoginStatus]);

  return null;
};

export default Logout;